import { useSelector } from "react-redux";

export default function useRestaurantTimeZone() {
	return useSelector((state) => state.landing.restaurantTimeZone);
}
